import { atomWithReset } from "jotai/utils";
export const collapseAtom = atomWithReset({
    leftMenu: true,
    rightMenu: false
});
